import { BaseApiService } from '@/_services/baseApi.service'

export class InstructorService extends BaseApiService {
  constructor () {
    super()
  }

  list (page = 0, schoolId = '', courseCode = '', size = 25, query = '') {
    const baseUrl = `${process.env.VUE_APP_BASE_URL}/v1/instructor/list`
    const url = baseUrl + `?page=${page}&schoolId=${schoolId}&courseCode=${courseCode}&size=${size}&query=${query}`
    return this.sendGetRequest(url)
  }

  responseList (body) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/instructor/response/list`
    return this.sendPostRequest(url, body)
  }

  deleteInstructor (personId, schoolId) {
    // const url = `${process.env.VUE_APP_BASE_URL}/v1/person/${personId}`
    const url = `${process.env.VUE_APP_BASE_URL}/v1/instructor/delete-school/${personId}/${schoolId}`
    return this.sendDeleteRequest(url)
  }

  generateLoginPassword (schoolId) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/instructor/school/${schoolId}/login&password`
    return this.sendPostRequest(url, null)
  }
}

export default new InstructorService()
